class CartDrawerCountdown extends HTMLElement {
  connectedCallback() {
    if (this.interval) window.clearInterval(this.interval);

    this.timerEl = this.querySelector('[data-countdown-time]');
    this.duration = Math.max(1, Number(this.dataset.durationMinutes || 5)) * 60 * 1000;
    this.storageKey = this.dataset.storageKey || `theme-cart-countdown-${this.duration}`;

    let deadline = 0;
    try {
      deadline = Number(sessionStorage.getItem(this.storageKey) || 0);
    } catch (error) {
      // sessionStorage can be unavailable in restricted browsing contexts.
    }

    if (!deadline || deadline <= Date.now()) {
      deadline = Date.now() + this.duration;
      try {
        sessionStorage.setItem(this.storageKey, String(deadline));
      } catch (error) {
        // The countdown still works even when storage is unavailable.
      }
    }

    this.deadline = deadline;
    this.updateCountdown();
    this.interval = window.setInterval(() => this.updateCountdown(), 1000);
  }

  disconnectedCallback() {
    if (this.interval) {
      window.clearInterval(this.interval);
      this.interval = null;
    }
  }

  updateCountdown() {
    if (!this.timerEl) return;

    const remaining = Math.max(0, this.deadline - Date.now());
    const totalSeconds = Math.ceil(remaining / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    this.timerEl.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

    if (remaining <= 0 && this.interval) {
      window.clearInterval(this.interval);
      this.interval = null;
    }
  }
}

if (!customElements.get('cart-drawer-countdown')) {
  customElements.define('cart-drawer-countdown', CartDrawerCountdown);
}
